<script>
  import moment from 'moment';
  import conciliacaoProjetoServico from '../servico';

  const CRITERIOS = {
    'e-mail': { rotulo: 'e-mail', cls: 'forte' },
    'nome': { rotulo: 'nome', cls: 'forte' },
    'valor': { rotulo: 'só valor', cls: 'fraco' },
    'saque': { rotulo: 'saque', cls: 'fraco' },
  };

  export default {
    props: {
      idProjetoCript: { type: String, required: true },
      nomeConta: { type: String, default: '' },
      dataIni: { type: Date, default: null },
      dataFim: { type: Date, default: null },
    },
    data() {
      return {
        carregando: false,
        erro: '',
        ciclos: [],
        abertos: {},
        conciliando: 0,
        houveConciliacao: false,
      };
    },
    computed: {
      periodoTexto() {
        if (!this.dataIni || !this.dataFim) return '';
        return moment(this.dataIni).format('DD/MM/YYYY') + ' a ' + moment(this.dataFim).format('DD/MM/YYYY');
      },
      prontos() { return this.ciclos.filter(c => c.completo).length; },
    },
    mounted() { this.carregar(); },
    methods: {
      carregar() {
        this.carregando = true;
        this.erro = '';
        const di = this.dataIni ? moment(this.dataIni).format('YYYY-MM-DD') : '';
        const df = this.dataFim ? moment(this.dataFim).format('YYYY-MM-DD') : '';
        conciliacaoProjetoServico.ciclosSaque(this.idProjetoCript, di, df)
          .then(ciclos => {
            this.ciclos = ciclos || [];
            const abertos = {};
            this.ciclos.forEach(c => { abertos[c.idExtratoSaque] = c.completo; });
            this.abertos = abertos;
            this.carregando = false;
          })
          .catch(() => {
            this.carregando = false;
            this.erro = 'Não foi possível montar os ciclos de saque.';
          });
      },
      alternar(ciclo) {
        this.$set(this.abertos, ciclo.idExtratoSaque, !this.abertos[ciclo.idExtratoSaque]);
      },
      formatar(valor) {
        return (+valor || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      },
      criterio(chave) { return CRITERIOS[chave] || { rotulo: chave, cls: 'fraco' }; },
      resumoHistorico(texto) {
        const limpo = (texto || '').replace(/^CONVERSAO DE MOEDA PAYPAL\s*/i, '').replace(/^RECEBIMENTO PAYPAL\s*/i, '');
        return limpo.split(' · ').slice(0, 2).join(' · ');
      },
      conciliar(ciclo) {
        if (!ciclo.completo || this.conciliando) return;

        const lancamentos = ciclo.pares.map(p => p.lancamento).concat(ciclo.tarifas);
        const payload = {
          tipo: 2,
          observacao: 'Ciclo de saque PayPal de ' + ciclo.dataSaque,
          esquerda: lancamentos.map(l => ({ idLancamento: l.idLancamento, idLancRateio: 0, idExtrato: 0, valor: l.valor })),
          direita: ciclo.pares.map(p => ({ idLancamento: 0, idLancRateio: 0, idExtrato: p.extrato.idExtrato, valor: p.extrato.valor })),
        };

        this.conciliando = ciclo.idExtratoSaque;
        conciliacaoProjetoServico.conciliarBanco(this.idProjetoCript, payload)
          .then(() => {
            this.conciliando = 0;
            this.houveConciliacao = true;
            toastr.success('Ciclo do saque de ' + ciclo.dataSaque + ' conciliado: ' + payload.direita.length
              + ' linha(s) do extrato e ' + payload.esquerda.length + ' lançamento(s).');
            this.carregar();
          })
          .catch(res => {
            this.conciliando = 0;
            toastr.error(res && res.body && res.body.message ? res.body.message : 'Não foi possível conciliar o ciclo.');
          });
      },
      sair() { this.$emit('fechar', this.houveConciliacao); },
    },
  }
</script>

<template>
  <div class="cs-ov">
    <div class="cs-modal">
      <div class="cs-head">
        <div class="cs-head-ic"><i class="fa fa-exchange"></i></div>
        <div class="cs-head-txt">
          <h4>Ciclos de saque</h4>
          <small>{{ nomeConta }}<template v-if="periodoTexto"> · saques de {{ periodoTexto }}</template></small>
        </div>
        <div class="cs-head-resumo" v-if="!carregando && ciclos.length">
          <b>{{ prontos }}</b> de {{ ciclos.length }}
          <small>prontos para conciliar</small>
        </div>
      </div>

      <div class="cs-aj">
        Cada saque zera o saldo do PayPal. As conversões em reais desde o saque anterior pareiam com os créditos que o
        Desktop lançou pelo <b>bruto equivalente</b> (até R$ 0,01 de diferença), e a tarifa única do saque fecha a conta.
      </div>

      <div class="cs-corpo">
        <div v-if="carregando" class="cs-msg"><i class="fa fa-spinner fa-pulse fa-2x"></i></div>
        <div v-else-if="erro" class="cs-msg cs-erro">{{ erro }}</div>
        <div v-else-if="!ciclos.length" class="cs-vazio">
          <i class="fa fa-inbox"></i>
          <b>Nenhum saque no período</b>
          <span>O ciclo aparece quando o extrato do PayPal traz um saque que zera o saldo.</span>
        </div>

        <div v-for="ciclo in ciclos" :key="ciclo.idExtratoSaque" class="cs-ciclo" :class="{ 'cs-ok': ciclo.completo }">
          <div class="cs-ciclo-topo" @click="alternar(ciclo)">
            <i class="fa cs-seta" :class="abertos[ciclo.idExtratoSaque] ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
            <div class="cs-ciclo-tit">
              Saque de <b>{{ ciclo.dataSaque }}</b> · <span class="mono">R$ {{ formatar(ciclo.valorSaque) }}</span>
              <span v-if="ciclo.saqueConciliado" class="cs-chip">saque conciliado</span>
              <span v-else class="cs-chip cs-chip-alerta">saque entra no ciclo</span>
            </div>
            <span v-if="ciclo.completo" class="cs-sit cs-sit-ok"><i class="fa fa-check-circle"></i> Pronto</span>
            <span v-else class="cs-sit cs-sit-pend"><i class="fa fa-exclamation-circle"></i> Incompleto</span>
          </div>

          <div v-if="abertos[ciclo.idExtratoSaque]" class="cs-ciclo-corpo">
            <div v-if="ciclo.motivo" class="cs-motivo">{{ ciclo.motivo }}</div>

            <table v-if="ciclo.pares.length || ciclo.tarifas.length || ciclo.extratoSemPar.length" class="cs-tab">
              <thead>
                <tr>
                  <th colspan="3">Extrato</th>
                  <th></th>
                  <th colspan="3">Lançamento do Manager</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="par in ciclo.pares" :key="'p' + par.extrato.idExtrato">
                  <td class="cs-dt">{{ par.extrato.data }}</td>
                  <td class="cs-hist" :title="par.extrato.historico">{{ resumoHistorico(par.extrato.historico) }}</td>
                  <td class="tr mono">{{ formatar(par.extrato.valor) }}</td>
                  <td class="cs-meio">
                    <span class="cs-crit" :class="criterio(par.criterio).cls">{{ criterio(par.criterio).rotulo }}</span>
                    <small v-if="par.brutoEquivalente" class="mono">eq. {{ formatar(par.brutoEquivalente) }}</small>
                  </td>
                  <td class="cs-dt">{{ par.lancamento.data }}</td>
                  <td class="cs-hist" :title="par.lancamento.historico">{{ par.lancamento.historico }}</td>
                  <td class="tr mono">{{ formatar(par.lancamento.valor) }}</td>
                </tr>
                <tr v-for="t in ciclo.tarifas" :key="'t' + t.idLancamento" class="cs-tarifa">
                  <td colspan="3" class="cs-vazio-cel">tarifa do saque</td>
                  <td class="cs-meio"><span class="cs-crit fraco">tarifa</span></td>
                  <td class="cs-dt">{{ t.data }}</td>
                  <td class="cs-hist" :title="t.historico">{{ t.historico }}</td>
                  <td class="tr mono">{{ formatar(t.valor) }}</td>
                </tr>
                <tr v-for="e in ciclo.extratoSemPar" :key="'s' + e.idExtrato" class="cs-sem">
                  <td class="cs-dt">{{ e.data }}</td>
                  <td class="cs-hist" :title="e.historico">{{ resumoHistorico(e.historico) }}</td>
                  <td class="tr mono">{{ formatar(e.valor) }}</td>
                  <td class="cs-meio"><span class="cs-crit falta">sem par</span></td>
                  <td colspan="3" class="cs-vazio-cel">nenhum lançamento com o bruto equivalente</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td colspan="2">Extrato</td>
                  <td class="tr mono">{{ formatar(ciclo.somaExtrato) }}</td>
                  <td></td>
                  <td colspan="2">Lançamentos</td>
                  <td class="tr mono">{{ formatar(ciclo.somaLancamentos) }}</td>
                </tr>
              </tfoot>
            </table>

            <div v-if="ciclo.completo" class="cs-acao">
              <button type="button" class="btn btn-primary btn-sm" :disabled="!!conciliando" @click="conciliar(ciclo)">
                <i class="fa" :class="conciliando === ciclo.idExtratoSaque ? 'fa-spinner fa-pulse' : 'fa-check'"></i>
                Conciliar ciclo
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="cs-foot">
        <div class="cs-foot-info">Saque que a automática não casou (a transferência cai no dia seguinte) entra no próprio ciclo.</div>
        <button type="button" class="cs-sair" @click="sair"><i class="fa fa-sign-out"></i> Sair</button>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .cs-ov { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(16,24,40,.45); z-index: 2100; display: flex; align-items: center; justify-content: center; padding: 16px; }
  .cs-modal { width: 1080px; max-width: 97vw; max-height: 90vh; display: flex; flex-direction: column; background: #fff; border-radius: 8px; box-shadow: 0 18px 48px rgba(16,24,40,.28); overflow: hidden; }
  .cs-head { flex: 0 0 auto; display: flex; align-items: center; gap: 14px; padding: 15px 20px; background: #f7f9fa; border-bottom: 1px solid #e6e9ed; }
  .cs-head-ic { flex: none; width: 38px; height: 38px; border-radius: 8px; background: #e8f0fa; color: #2b6cb0; display: flex; align-items: center; justify-content: center; font-size: 17px; }
  .cs-head-txt { flex: 1 1 auto; min-width: 0; }
  .cs-head-txt h4 { margin: 0; font-size: 16px; font-weight: 600; color: #1c2024; }
  .cs-head-txt small { display: block; margin-top: 2px; font-size: 12px; color: #6b747e; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .cs-head-resumo { flex: none; text-align: right; font-size: 13px; color: #4b545e; }
  .cs-head-resumo b { font-size: 18px; color: #1c2024; }
  .cs-head-resumo small { display: block; font-size: 11.5px; color: #8a939c; }
  .cs-aj { flex: 0 0 auto; padding: 10px 20px; font-size: 12px; color: #5b6570; line-height: 1.5; border-bottom: 1px solid #eef1f4; }

  .cs-corpo { flex: 1 1 auto; min-height: 200px; overflow: auto; padding: 12px 20px 16px; }
  .cs-msg { padding: 40px 10px; text-align: center; color: #8a939c; font-size: 13px; }
  .cs-erro { color: #a13c3c; }
  .cs-vazio { display: flex; flex-direction: column; align-items: center; gap: 6px; padding: 44px 16px; text-align: center; color: #6b747e; font-size: 12.5px; }
  .cs-vazio > .fa { font-size: 30px; color: #b9c8da; }
  .cs-vazio > b { font-size: 14px; color: #3b444d; }

  .cs-ciclo { border: 1px solid #e3e8ee; border-left: 3px solid #d69e2e; border-radius: 7px; margin-bottom: 9px; background: #fff; }
  .cs-ciclo.cs-ok { border-left-color: #18a689; }
  .cs-ciclo-topo { display: flex; align-items: center; gap: 10px; padding: 10px 12px; cursor: pointer; user-select: none; }
  .cs-ciclo-topo:hover { background: #fafbfc; }
  .cs-seta { flex: none; width: 12px; color: #8a939c; font-size: 11px; }
  .cs-ciclo-tit { flex: 1 1 auto; min-width: 0; font-size: 13px; color: #2a3038; }
  .cs-chip { margin-left: 8px; padding: 1px 8px; border-radius: 9px; background: #e8f5ef; color: #0a6d4d; font-size: 11px; font-weight: 600; }
  .cs-chip-alerta { background: #fff4de; color: #8a6d1f; }
  .cs-sit { flex: none; font-size: 12px; font-weight: 600; }
  .cs-sit-ok { color: #0a6d4d; }
  .cs-sit-pend { color: #a06b00; }
  .cs-ciclo-corpo { padding: 0 12px 12px; }
  .cs-motivo { margin: 2px 0 10px; padding: 8px 10px; border-radius: 5px; background: #fff8e6; border: 1px solid #f0dfae; color: #8a6d1f; font-size: 12px; }

  .cs-tab { width: 100%; border-collapse: collapse; font-size: 12px; table-layout: fixed; }
  .cs-tab th { padding: 5px 6px; font-size: 10.5px; font-weight: 600; text-transform: uppercase; letter-spacing: .04em; color: #7b848e; border-bottom: 1px solid #e6e9ed; text-align: left; }
  .cs-tab td { padding: 5px 6px; border-bottom: 1px solid #f1f3f5; color: #2a3038; vertical-align: middle; }
  .cs-tab tfoot td { border-bottom: none; border-top: 1px solid #e6e9ed; font-weight: 600; color: #1c2024; }
  .cs-dt { width: 78px; color: #6b747e; white-space: nowrap; }
  .cs-hist { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .cs-meio { width: 110px; text-align: center; white-space: nowrap; }
  .cs-meio small { display: block; font-size: 10.5px; color: #8a939c; }
  .cs-tab td.tr { width: 92px; text-align: right; }
  .cs-crit { display: inline-block; padding: 1px 7px; border-radius: 9px; font-size: 10.5px; font-weight: 600; }
  .cs-crit.forte { background: #e8f5ef; color: #0a6d4d; }
  .cs-crit.fraco { background: #eef1f4; color: #5b6570; }
  .cs-crit.falta { background: #fdecec; color: #a13c3c; }
  .cs-vazio-cel { color: #9aa3ac; font-style: italic; }
  .cs-tarifa td { background: #fbfcfd; }
  .cs-sem td { background: #fffaf8; }
  .cs-acao { display: flex; justify-content: flex-end; margin-top: 10px; }

  .cs-foot { flex: 0 0 auto; display: flex; align-items: center; justify-content: space-between; gap: 10px; padding: 12px 20px; border-top: 1px solid #e6eaee; }
  .cs-foot-info { font-size: 12px; color: #6b747e; }
  .cs-sair { display: inline-flex; align-items: center; gap: 7px; background: #fdf1f1; border: 1px solid #e4d7d7; border-radius: 5px; padding: 8px 18px; font-size: 12.5px; color: #a13c3c; font-weight: 600; }
  .cs-sair:hover { background: #fbe6e6; }
  .mono { font-family: 'IBM Plex Mono', Consolas, monospace; font-variant-numeric: tabular-nums; }

  @media (max-width: 640px) {
    .cs-head-resumo { display: none; }
    .cs-tab { table-layout: auto; }
  }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/conciliacao-projeto/componentes/CicloSaqueModal.vue